import React, { useState } from "react";
import { ChatButton } from "./CustomButtons";
import ChatbotIcon from "../../assets/icon/chatbot-icon.svg";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from "primereact/button";
import SendIcon from "../../assets/icon/send-icon.svg";
import AvatarImg from "../../assets/images/avatar.png";
import { Avatar } from "primereact/avatar";
import { useDispatch } from "react-redux";
import { chatBotUserChat } from "../../store/slices/userSlice";

export default function ChatBoat() {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [chat, setChat] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState([]);
  const [loading, setLoading] = useState(false)

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleOpenChat = () => {
    setIsOpen(true);
  };

  const sendQuery = () => {
    if (currentQuestion) {
      const newChat = [...chat, { question: currentQuestion }];
      setChat(newChat);
      setCurrentQuestion("");
      dispatch(
        chatBotUserChat({
          question: currentQuestion,
          prevChat: newChat,
          setChat,
          setLoading
        })
      );
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      sendQuery();
    }
  };

  return (
    <div
      className="fixed p-3 bottom-0 right-0 h-auto"
      style={{ zIndex: "9999" }}
    >
      <div className="relative">
        {isOpen && (
          <div className="chatbot-container">
            {/* Header */}
            <div className="chatbot-header">
              <div className="chatbot-avatar flex align-items-center">
                <Avatar image={AvatarImg} shape="circle" />
              </div>
              <div className="chatbot-title">
                <span>Smartly</span>
                <small>I reply immediately</small>
              </div>
              <button className="chatbot-close-btn" onClick={handleClose}>
                <i className="pi pi-times"></i>
              </button>
            </div>

            {/* Messages */}
            <div className="chatbot-messages">
              <div className="chatbot-message">
                <p className="m-0">
                  Welcome to our store! 👋 Whether you have a specific question,
                  we’re here for you. What would you like to know?
                </p>
              </div>
              {chat?.map((item, index) => (
                <React.Fragment key={`chat-${index}`}>
                  {item?.question && (
                    <div className="user-input">
                      <p className="m-0">{item.question}</p>
                    </div>
                  )}
                  {item?.answer && (
                    <div className="chatbot-message">
                      <p className="m-0">{item.answer}</p>
                    </div>
                  )}
                </React.Fragment>
              ))}
            </div>
            {/* chatbot footer */}
            <div className="chatbot-footer border-top-1 border-300">
              <div className="p-inputgroup flex items-end">
                {/* <InputText
                  placeholder="Send a message.. "
                  className="border-noround border-none"
                  name="currentQuestion"
                  value={currentQuestion}
                  onChange={(e) => setCurrentQuestion(e.target.value)}
                  onKeyPress={handleKeyPress}
                /> */}
                <InputTextarea
                  placeholder="Send a message.. "
                  className="border-noround border-none outline-none focus:outline-none focus:border-none shadow-none"
                  name="currentQuestion"
                  value={currentQuestion}
                  onChange={(e) => setCurrentQuestion(e.target.value)}
                  autoResize
                  onKeyPress={handleKeyPress}
                />
                <Button
                  className="bg-transparent border-none text-black-alpha-90 mb-4"
                  onClick={sendQuery}
                  disabled={loading}
                >
                  {loading ? <i className="pi pi-spinner pi-spin" /> : <img src={SendIcon} alt="" />}
                </Button>
              </div>
            </div>
          </div>
        )}
        <ChatButton
          extraClassNames="ml-auto chat-bot-btn"
          onClick={handleOpenChat}
          style={{ width: "62px", height: "62px", borderRadius: "50%" }}
        >
          <img src={ChatbotIcon} alt="" />
        </ChatButton>
      </div>
    </div>
  );
}
